// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class UnderlierOptionInfo {
    constructor(name, instrumentGroupId, instrumentId) {
        this.name = name;
        this.instrumentGroupId = instrumentGroupId;
        this.instrumentId = instrumentId;
    }
}
